import { useTranslation } from 'react-i18next';
import { CalendarLayout, StepCards, SupportEmailText } from '../components';
import { SUPPORT_EMAIL } from '../constants';
import imgPorterAgenda from '../../../assets/images/img-porter-agenda.png';
import * as S from './styles';

const PORTER_SITE_URL = 'https://www.portergroup.com.br';

export default function CalendarInstructions() {
  const [t] = useTranslation('calendar');

  const translatedSteps = t('instructions.steps', { returnObjects: true });
  const steps = Array.isArray(translatedSteps) ? translatedSteps : [];

  return (
    <CalendarLayout wide>
      <S.Hero>
        <S.HeroImage src={imgPorterAgenda} alt="" />
        <S.HeroBody>
          <S.HeroBadge>{t('instructions.badge')}</S.HeroBadge>
          <S.HeroHeading>{t('instructions.title')}</S.HeroHeading>
          <S.HeroSubtitle>{t('instructions.description')}</S.HeroSubtitle>
        </S.HeroBody>
      </S.Hero>

      <S.SectionHeading>{t('instructions.steps-heading')}</S.SectionHeading>
      <StepCards steps={steps} layout="grid" />

      <S.Banner>
        <S.BannerBody>
          <S.BannerTitle>{t('instructions.banner.title')}</S.BannerTitle>
          <S.BannerText>{t('instructions.banner.description')}</S.BannerText>
        </S.BannerBody>
        <S.BannerButton
          href={PORTER_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('instructions.banner.cta')}
        </S.BannerButton>
      </S.Banner>

      <S.Paragraph $align="center">
        <SupportEmailText
          i18nKey="instructions.support"
          email={SUPPORT_EMAIL}
        />
        {` ${t('instructions.trademarks')}`}
      </S.Paragraph>
    </CalendarLayout>
  );
}
